/**
 * Determines the click target based on the provided settings.
 *
 * @param {Object} settings - The settings object.
 * @param {boolean} settings.isNoResultsPage - Indicates whether the current page is a "no results" page.
 * @param {string} settings.clickTarget - The click target value that comes from the HTML.
 * @returns {string} The click target determined based on the provided settings.
 */
function getClickTarget(settings) {
  if (settings.isNoResultsPage) {
    return "Zero Results Card";
  }

  return settings.clickTarget;
}

export default getClickTarget;